import axios from "axios";

import { BASE_URL } from "../../src/utils/api_base_url_configration";
import handleError from "../utils/handleError";



export const loginServ = async (formData) => {
  try {
    const response = await axios.post(BASE_URL + "user/login-with-password", formData);
    return response;
  } catch (error) {
    handleError(error);
  }
};
export const googleLoginServ = async (formData) => {
  try {
    const response = await axios.post(BASE_URL + "user/google-login", formData);
    return response;
  } catch (error) {
    handleError(error);
  }
};
export const signupServ = async (formData) => {
  try {
    const response = await axios.post(BASE_URL + "user/sign-up", formData);
    return response;
  } catch (error) {
    handleError(error);
  }
};
export const verifyOtpServ = async (formData) => {
  try {
    const response = await axios.post(BASE_URL + "user/sign-up", formData);
    return response;
  } catch (error) {
    handleError(error);
  }
};
export const resendOtpServ = async (formData) => {
  try {
    const response = await axios.post(BASE_URL + "user/sign-up", formData);
    return response;
  } catch (error) {
    handleError(error);
  }
};
export const resetPasswordServ = async (token, formData) => {
  try {
    const response = await axios.post(BASE_URL + "user/reset-password/"+token, formData);
    return response;
  } catch (error) {
    handleError(error);
  }
};
export const forgetPasswordServ = async (formData) => {
  try {
    const response = await axios.post(BASE_URL + "user/forgot-password", formData);
    return response;
  } catch (error) {
    handleError(error);
  }
};
